import Model from "./model";

export default class Controller {
    constructor(showPlaceholders, companyId, onDeleteFunc, onSaveFunc, onCancelFunc, languages, canEditCompany, loader, overrideLocaleCode, accountLocaleCode, titleText, type, channel, onSendTestEmail,) {
        this.model = new Model(showPlaceholders, companyId, onDeleteFunc, languages, canEditCompany, loader, titleText, type, channel)
        const selectedLocaleCode = overrideLocaleCode ? overrideLocaleCode : accountLocaleCode
        this.model.setSelectedLocaleCode(selectedLocaleCode)
        this.onCancelFunc = onCancelFunc
        this.onSaveFunc = onSaveFunc
        this.onSendTestEmail = onSendTestEmail
    }

    setTemplateName(value) {
        this.model.setTemplateName(value)
    }

    setIsPublic(value) {
        this.model.setIsPublic(value)
    }

    handleSave() {
        const saveData = this.model.getSaveData()

        this.model.setSentData(saveData)
        this.onSaveFunc(saveData)
    }

    handleSendTestEmail() {
        const saveData = this.model.getSaveData()
        this.onSendTestEmail(saveData)
    }

    handleCancel() {
        this.onCancelFunc()
    }

    setSelectedLocaleCode(value) {
        this.model.setSelectedLocaleCode(value)
        if (!this.model.getSelectedRow()) {
            this.addRow(this.model.getSelectedLocaleCode())
        }
    }

    setSubject(value) {
        this.model.setSubject(value)
    }

    setContent(value) {
        this.model.setContent(value)
    }

    showValidationErrors (errors) {
        this.model.clearErrors()

        for (let error of Array.from(errors)) {
            this.model.setError(error)
        }

        this.model.setGlobalErrors(errors)
    };

    loadTemplate (template) {
        this.model.clearErrors()
        this.model.setRows(template.rows)
        this.model.setTemplateName(template.template_name)
        this.model.setCreatorId(template.creator_id)
        this.model.setIsPublic(template.is_public)
        this.model.setTemplateId(template.id)

        if (!this.model.getSelectedRow()) {
            this.addRow(this.model.getSelectedLocaleCode())
        }
    }

    addRow(localeCode) {
        this.model.addRow({
            content: '',
            subject: '',
            locale_code: localeCode
        })
    }
}